/* OATENTIK — moves the 30-day journey timeline out of the buy column into a
   standalone band directly above the reviews section ("What people say about
   OATENTIK") — Marjana, 2026-08-21.

   The timeline itself is built by oatentik-hero.js, which clones
   #oatentik-journey-template in after the Quality-and-certificates accordion
   and re-checks for ~9s from its boot retry loop. That file is auto-extracted
   from the hero section (its own first line says so), so editing it risks the
   change being silently regenerated away; this small mover relocates the
   finished node instead and leaves a HIDDEN STUB behind, so the hero's
   info-scoped dedupe check (`info.querySelector('.oatentik-journey-slider')`)
   keeps passing and its retry loop never re-injects a second copy.

   Loaded by sections/oatentik-minimal-ingredients-v2.liquid → flagship only,
   like oatentik-pdp-r5.css, which lays out the .oatentik-journey-standalone
   wrapper this file creates. If the reviews section is ever removed, the
   timeline simply stays in its old buy-column spot. */
(function () {
  if (window.__oatJourneyMoveInit) return;
  window.__oatJourneyMoveInit = true;

  function tryMove() {
    var info = document.querySelector('.product__info-container, .product__info-wrapper');
    if (!info) return false;
    var slider = info.querySelector('.oatentik-journey-slider:not([data-oat-stub])');
    if (!slider) return false;

    var reviews = document.querySelector('.oat-pr');
    var host = reviews ? (reviews.closest('.shopify-section') || reviews) : null;
    /* No reviews section on this page: stop retrying, leave the timeline
       where the hero put it. */
    if (!host || !host.parentNode) return true;

    var stub = document.createElement('div');
    stub.className = 'oatentik-journey-slider';
    stub.setAttribute('data-oat-stub', '1');
    stub.hidden = true;
    stub.style.display = 'none';
    slider.parentNode.insertBefore(stub, slider);

    var wrap = document.createElement('div');
    wrap.className = 'oatentik-journey-standalone page-width';
    host.parentNode.insertBefore(wrap, host);
    wrap.appendChild(slider);
    return true;
  }

  function start() {
    if (tryMove()) return;
    /* Poll a beat faster than the hero's 300ms loop, and outlast it
       (100 × 150ms = 15s vs the hero's ~9.3s). */
    var tries = 0;
    var t = setInterval(function () {
      if (tryMove() || ++tries > 100) clearInterval(t);
    }, 150);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
